import axios from 'axios';
import { fetchConfig } from '../config';

// Detect if running on localhost
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Create axios instance
const apiClient = axios.create({
  baseURL: isLocalhost 
    ? 'http://localhost:8000' 
    : `https://api.${window.location.hostname.replace('webapp.', '')}`
});

// Global subscription error state
let subscriptionErrorCallback = null;

export const setSubscriptionErrorCallback = (callback) => {
  subscriptionErrorCallback = callback;
};

// Only fetch config if not localhost
if (!isLocalhost) {
  let configPromise = null;
  const initializeConfig = async () => {
    if (!configPromise) {
      configPromise = fetchConfig().then(config => {
        apiClient.defaults.baseURL = config.api.baseUrl;
        return config;
      }).catch(err => {
        console.error('Failed to fetch config:', err);
      });
    }
    return configPromise;
  };

  initializeConfig();

  apiClient.interceptors.request.use(
    async (config) => {
      await configPromise;
      const cognitoConfig = await fetchConfig();
      const keyPrefix = `CognitoIdentityServiceProvider.${cognitoConfig.cognito.clientId}`;
      const username = localStorage.getItem(`${keyPrefix}.LastAuthUser`);
      const token = username ? localStorage.getItem(`${keyPrefix}.${username}.idToken`) : null;
      if (token && !config.headers['Authorization']) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
} else {
  apiClient.interceptors.request.use(
    async (config) => {
      const cognitoConfig = await fetchConfig();
      const keyPrefix = `CognitoIdentityServiceProvider.${cognitoConfig.cognito.clientId}`;
      const username = localStorage.getItem(`${keyPrefix}.LastAuthUser`);
      const token = username ? localStorage.getItem(`${keyPrefix}.${username}.idToken`) : null;
      if (token && !config.headers['Authorization']) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

// Response interceptor to handle subscription errors
apiClient.interceptors.response.use(
  (response) => {
    // Hide banner on successful response from protected endpoints (not subscription status or config)
    const url = response.config.url || '';
    const isExcludedEndpoint = url.includes('/api/subscription/status') || url.includes('/config');
    
    if (!isExcludedEndpoint && subscriptionErrorCallback) {
      subscriptionErrorCallback(false);
    }
    return response;
  },
  (error) => {
    // Handle 402 Payment Required (subscription inactive)
    if (error.response?.status === 402) {
      console.log('Subscription required - triggering banner');
      if (subscriptionErrorCallback) {
        subscriptionErrorCallback(true);
      }
    }
    // Don't handle 401 here - let useAuth.js handle token refresh
    return Promise.reject(error);
  }
);

export default apiClient;
